import * as React from "react";
import {ReactNode} from "react";

export interface TechnicalBreakProps {
  title: ReactNode
  content: ReactNode
  period: ReactNode
  logo?: ReactNode
  loader?: ReactNode
}

export const TechnicalBreak = (props: TechnicalBreakProps) => {
  return <div className="technical-break">
    <div className="technical-break__header">
      {props.logo}
    </div>
    <div className="technical-break__body">
      {props.loader}
      <h3>{props.title}</h3>
      <span>{props.content}</span>
      <span>&nbsp;</span>
      <span className="time">{props.period}</span>
    </div>
  </div>;
};



// WEBPACK FOOTER //
// ./src/Modules/TechnicalBreak/Component/TechnicalBreak.Component.tsx